
function calculateBreakeven(upfront, payoff, dailyCost, halvingTs, maxDuration) {
  const now = Date.now();
  const r = upfront / (payoff - dailyCost);
  if (r < 0) return ;

  if (!halvingTs || now > halvingTs) {
    return r;
  } else {
    const preHavlingDays = (halvingTs - now) / 86400000;

    if (preHavlingDays > r) {
      return r;
    } else {
      if (payoff - 2 * dailyCost < 0) return ;

      const rh = (2 * upfront - payoff * preHavlingDays) / (payoff - 2 * dailyCost);
      return rh < maxDuration ? rh : undefined;
    }
  }
}

export { calculateBreakeven }